import { Box, Stack } from "@mui/material";
import BookingRating from "./BookingRating";
import SmartActionsPanel from "./SmartActionPanel";
import ActionItemCard from "./ActionItems";
import type { SmartAction, ActionItem } from "../../../types/types";
import BookingSidebar from "../../../components/BookingsSidebar";
import { BookingData } from "../../../../types/view-booking";

type SidebarMode = "ratingOnly" | "smartActionsOnly" | "actionsOnly" | "bookingSidebar";

interface SidebarProps {
  rating: number;
  smartActions: SmartAction[];
  actionItems: ActionItem[];
  mode?: SidebarMode;
  bookingData?: BookingData | null;
  onOpenAIAssistant?: (mode: "review" | "thankyou" | "anniversary") => void;
}

export default function Sidebar({
  rating,
  smartActions,
  actionItems,
  mode = "ratingOnly",
  bookingData,
  onOpenAIAssistant,
}: SidebarProps) {
  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      {mode === "ratingOnly" && (
        <Box sx={{ height: "100%" }}>
          <BookingRating rating={rating} />
        </Box>
      )}

      {mode === "smartActionsOnly" && (
        <Box sx={{ height: "100%" }}>
          <SmartActionsPanel actions={smartActions} />
        </Box>
      )}

      {mode === "actionsOnly" && (
        <Stack spacing={1}>
          {actionItems.map((item, index) => (
            <ActionItemCard key={index} item={item} />
          ))}
        </Stack>
      )}

      {mode === "bookingSidebar" && (
        <BookingSidebar bookingData={bookingData} onOpenAIAssistant={onOpenAIAssistant} />
      )}
    </Box>
  );
}